import './KpiBoxedValues.scss';
import React from "react";
import {observer} from "mobx-react-lite";
import {Card, CardContent, Grid, Typography} from "@mui/material";
import type {GridProps} from "@mui/material/Grid";
import {HelpComponent} from "../help-component/HelpComponent.tsx";

const SIZES: Record<number, GridProps['size']> = {
    1: {xs: 12},
    2: {xs: 12, sm: 6},
    3: {xs: 12, sm: 4},
    4: {xs: 12, sm: 6, md: 3},
}

export type KpiBoxedValue = {
    key?: string
    title: string
    subtitle: React.ReactNode
    className?: string
    help?: React.ReactNode
};
type Props = {
    values: KpiBoxedValue[]
}
export const KpiBoxedValues: React.FC<Props> = observer(({values}) =>
    <Grid container className="kpi-boxed-values" spacing={3}>
        {values.map(({key, title, subtitle, className, help}, i) =>
            <Grid key={key ?? i} size={SIZES[values.length] ?? SIZES[4]}>
                <Card variant="elevation" elevation={0} className={`kpi-card ${className ?? ''}`}>
                    <CardContent>
                        <Typography variant="h2" className="kpi-title" component="h2">
                            {title}
                            {help && <HelpComponent helpContent={help}/>}
                        </Typography>
                        <Typography variant="h2" className="kpi-value" component="h2">{subtitle}</Typography>
                    </CardContent>
                </Card>
            </Grid>
        )}
    </Grid>
)